export default function(props) {
  const keys = Object.keys(props);
  const dataset = {};
  keys.forEach((propKey) => {
    if (propKey.indexOf('data-') === 0) {
      dataset[propKey.substring(5)] = props[propKey];
    }
  });
  return dataset;
}
